import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Eye } from 'lucide-react';

/** Admin Center Archive Mode: the school is archived — AI Recording is not available. */
export const ArchiveBlockedScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="t-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div className="t-surface t-border" style={{ maxWidth: 440, width: '100%', borderRadius: 16, padding: '32px 28px', textAlign: 'center', borderWidth: 1, borderStyle: 'solid' }}>
        <div style={{
          width: 52, height: 52, borderRadius: '50%', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--surfaceSelected, rgba(79,70,229,0.1))', color: 'var(--primary-text, #4f46e5)',
        }}>
          <Lock size={24} aria-hidden />
        </div>
        <h1 className="t-text" style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>
          {t('archive.blocked_title', 'Access blocked')}
        </h1>
        <p className="t-muted" style={{ fontSize: 14, margin: 0, lineHeight: 1.5 }}>
          {t('archive.blocked_desc', "Your school's account is archived, so AI Recording isn't available. Contact your school administrator.")}
        </p>
      </div>
    </div>
  );
};

/** Admin Center Archive Mode: Grace period — watching only. */
export const ArchiveReadOnlyBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      style={{
        display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', fontSize: 13, lineHeight: 1.4,
        background: 'color-mix(in srgb, #f59e0b 14%, var(--card-bg, #fff))',
        borderBottom: '1px solid color-mix(in srgb, #f59e0b 40%, transparent)',
        color: 'var(--text-primary, #111827)',
      }}
    >
      <Eye size={16} aria-hidden style={{ flexShrink: 0, color: '#d97706' }} />
      <span>
        <strong>{t('archive.read_only_title', 'Read-only')}</strong>{' · '}
        {t('archive.read_only_desc', "Your school's account is read-only. You can watch videos, but recording, uploading, editing, sharing and deleting are turned off.")}
      </span>
    </div>
  );
};
